import React from "react";

export default function OperatorsTable() {
  return (
    <div className="ia-placeholder">
      <h3>👥 OperatorsTable</h3>
      <p>Tabela de operadores pendente.</p>
    </div>
  );
}
